import React from 'react';
import { ConditionalComponent } from 'components/ConditionalWrappers/ConditionalComponentWrapper/ConditionalComponent';
import { useIsDemoUser } from 'components/utilities/hooks/useIsDemoUser';

export const ShowNotDemoUserOnly = ({ children }) => {
  const isDemoUser = useIsDemoUser();

  return (
    <ConditionalComponent condition={!isDemoUser}>
      {children}
    </ConditionalComponent>
  );
};
